<script>
  export let bars = [];
  export let labels = [];
  export let showLabels = true;
</script>

<div class="ignorantBar">
  <div class="ignorantBar--inner">
    {#each bars as b}
      <div class="ignorantBar--bar {b.c}" style="width: {b.w}%" />
    {/each}
    {#if showLabels}
      <div class="ignorantBar--label">
        {#each labels as l, index}
          <span class="{l.c}" style={l.c === 'overlap' ? `left: ${bars[0].w + (100 - (bars[0].w + bars[1].w))}%` : ``}>{l.l}</span>
        {/each}
      </div>
    {/if}
  </div>
</div>

<style>


.ignorantBar {
    display: block;
    position: relative;
    width: 100%;
  }

  .ignorantBar--inner {
    display: block;
    height: 75px;
    position: relative;
    width: 100%;
  }

  .ignorantBar--bar {
    background: var(--clean) 5px center no-repeat;
    background-size: auto 75%;
    display: block;
    height: 75px;
    mix-blend-mode: multiply;
    position: absolute;
    top: 50%;
    transform: translate3d(0, -50%, 0);
  }

  .ignorantBar--bar.meloni {
    background-color: var(--meloni);
    background-image: url(/img/meloni-clean.webp);
    left: 0;
  }

  .ignorantBar--bar.schlein {
    background-color: var(--schlein);
    background-image: url(/img/schlein-clean.webp);
    background-position: right 5px center;
    right: 0;
  }

  .ignorantBar--label {
    display: block;
    font-family: 'Fira Mono', monospace;
    font-size: 12px;
    font-weight: 500;
    height: 16px;
    left: 0;
    line-height: 16px;
    position: absolute;
    right: 0;
    text-transform: uppercase;
    top: 100%;
    transform: translate3d(0, 2px, 0);
  }

  .ignorantBar--label span {
    height: 16px;
    left: 0;
    line-height: 16px;
    position: absolute;
    text-align: left;
    top: 0;
  }

  .ignorantBar--label .meloni {
    color: var(--meloni);
    padding-left: 10px;
  }

  .ignorantBar--label .schlein {
    color: var(--schlein);
    left: auto;
    padding-right: 10px;
    right: 0;
    text-align: right;
    transform: translate3d(0, 0, 0);
  }

  .ignorantBar--label .overlap {
    color: var(--overlap);
    left: auto;
    padding: 0 5px;
    text-align: center;
    transform: translate3d(-100%, 0, 0);
    white-space: nowrap;
  }

  .ignorantBar--label .overlap::after {
    content: ' ⚭';
    font-size: 14px;
    vertical-align: baseline;
  }
</style>